import React, { ReactElement } from 'react';
import { SafeHtml } from '@shared/ui';

export const reactElementAdapter = (content: string | ReactElement) => {
	if (!content) {
		return null;
	}

	if (React.isValidElement(content)) {
		return content as ReactElement;
	}

	if (typeof content === 'string') {
		return <SafeHtml tag="div" html={content} />;
	}

	return null;
};
